import { render } from "./CreateWorkerForm.vue?vue&type=template&id=38a7ae98"
import script from "./CreateWorkerForm.vue?vue&type=script&lang=ts"
export * from "./CreateWorkerForm.vue?vue&type=script&lang=ts"
script.render = render

export default script